angular
  .module('fca-used')
  .factory('wishlist', wishlistService);

wishlistService.$inject = ['$localStorage', 'uvl'];

function wishlistService($localStorage, uvl) {
  var instance = null;

  function Wishlist() {
    $localStorage.wishlist = $localStorage.wishlist || {};
    this.show = false;
    this.list = this.getList();
  }

  Wishlist.prototype.getList = function () {
    return Object.keys($localStorage.wishlist)
      .map(function (vehicleCode) {
        return $localStorage.wishlist[vehicleCode];
      })
      .sort(function (a, b) {
        return (new Date(b.added)).getTime() - (new Date(a.added)).getTime();
      })
      .map(function (item) {
        return item.vehicle;
      });
  };

  Wishlist.prototype.get = function (vehicleCode) {
    if ($localStorage.wishlist[vehicleCode]) {
      return $localStorage.wishlist[vehicleCode].vehicle;
    }
  };

  Wishlist.prototype.add = function (vehicle) {
    $localStorage.wishlist[vehicle.vehicleCode] = {
      added: new Date(),
      vehicle: vehicle
    };
    this.list.splice(0, 0, vehicle);
  };

  Wishlist.prototype.remove = function (vehicleCode) {
    delete $localStorage.wishlist[vehicleCode];
    this.list = this.getList();
  };

  Wishlist.prototype.setNotAvailable = function (vehicleCode) {
    if (!$localStorage.wishlist[vehicleCode]) {
      return;
    }
    $localStorage.wishlist[vehicleCode].vehicle.notAvailable = true;
    this.list = this.getList();
  };

  Wishlist.prototype.clear = function () {
    delete $localStorage.wishlist;
    this.list = [];
  };

  Wishlist.prototype.lockPageScroll = function () {
    angular.element(document).find('html').css('position', 'fixed');
    angular.element(document).find('body').css('position', 'fixed');
  };

  Wishlist.prototype.unlockPageScroll = function () {
    angular.element(document).find('html').css('position', 'static');
    angular.element(document).find('body').css('position', 'static');
  };

  Wishlist.prototype.open = function () {
    var self = this;
    angular.forEach(this.list, function (vehicle) {
      if (vehicle.notAvailable) {
        delete $localStorage.wishlist[vehicle.vehicleCode];
      }
    });
    this.list = this.getList();

    var codes = this.list.map(function (vehicle) {
      return vehicle.vehicleCode;
    });

    if (codes) {
      uvl.getVehicleDetails(codes)
        .then(function (vehicles) {
          self.show = true;
          self.lockPageScroll();
          var validCodes = vehicles.map(function (vehicle) {
            return vehicle.vehicleCode;
          });
          angular.forEach(codes, function (code) {
            if (validCodes.indexOf(code) === -1) {
              self.setNotAvailable(code);
            }
          });
        })
        .catch(function () {
          self.show = true;
          self.lockPageScroll();
        });
    } else {
      self.show = true;
      self.lockPageScroll();
    }
  };

  Wishlist.prototype.close = function () {
    this.show = false;
    this.unlockPageScroll();
  };

  if (!instance) {
    instance = new Wishlist();
  }
  return instance;
}
